export { APP_VERSION } from './version';
export const LOGO = 'https://unclewiener.com/cdn/shop/files/Uncle_Wieners_-_Logo_Color_72ppi.png';
